import React, { PureComponent } from "react";
import moment from "moment";

import Heading from "./../../Elements/Heading";
import pickaxe_insights_logo from "./../../../i/brand/pickaxe_small_circle.svg";
import { formatInsightText } from "./../../Utils/InsightsUtils.js";

class QueryInsightsFeedList extends PureComponent {
  render() {
    const {
      insight_text_markup,
      insight_markup_array,
      insight_timestamp,
      new_insight,
      text_size,
    } = this.props;

    return (
      <section className="row mb-4 insight-archive animated fadeIn">
        <div className="col-12">
          <img
            src={pickaxe_insights_logo}
            alt="Insights"
            className="mr-1 pickaxe_insights_logo"
          />
          <time className="insight-archive__time">
            <span className="insight-archive__timestamp">
              {moment.utc(insight_timestamp).local().format("MM/DD/YY")}{" "}
            </span>
          </time>

          {new_insight && (
            <span className="insight-archive__new-insight">New</span>
          )}

          <Heading size={text_size || 3} className={"insight__text mb-2 mt-1"}>
            <span
              dangerouslySetInnerHTML={{
                __html: formatInsightText(
                  insight_markup_array,
                  insight_text_markup
                ),
              }}
            />
          </Heading>
        </div>
      </section>
    );
  }
}

export default QueryInsightsFeedList;
